const TABLE_MOVEMENT_ACTION_REPLACE = 0
const TABLE_MOVEMENT_ACTION_COPY = 1

export {
	TABLE_MOVEMENT_ACTION_COPY,
	TABLE_MOVEMENT_ACTION_REPLACE,
}